import { useState, useEffect } from 'react';
import { ColumnConfig } from '../components/common/ColumnVisibilityMenu';

export const useColumnVisibility = (
  storageKey: string,
  defaultColumns: ColumnConfig[]
) => {
  const [columns, setColumns] = useState<ColumnConfig[]>(() => {
    const saved = localStorage.getItem(storageKey);
    if (saved) {
      try {
        const savedColumns = JSON.parse(saved);
        return defaultColumns.map(col => ({
          ...col,
          visible: savedColumns[col.id] ?? col.visible,
        }));
      } catch {
        return defaultColumns;
      }
    }
    return defaultColumns;
  });

  useEffect(() => {
    const visibility = columns.reduce((acc, col) => {
      acc[col.id] = col.visible;
      return acc;
    }, {} as Record<string, boolean>);
    localStorage.setItem(storageKey, JSON.stringify(visibility));
  }, [columns, storageKey]);

  const toggleColumn = (columnId: string) => {
    setColumns(prev =>
      prev.map(col =>
        col.id === columnId && !col.required
          ? { ...col, visible: !col.visible }
          : col
      )
    );
  };

  const resetDefaults = () => {
    setColumns(defaultColumns);
    localStorage.removeItem(storageKey);
  };

  const isColumnVisible = (columnId: string) => {
    return columns.find(col => col.id === columnId)?.visible ?? true;
  };

  return { columns, toggleColumn, resetDefaults, isColumnVisible };
};
